export function getUrlDomain(): string {
  const host = window.location.host
  const domain = host.split('.')[0]
  if (domain === '192') return 'localhost'
  return domain
}
